
<template>
  <div class="wrapper">
    <!-- <navbar-sas></navbar-sas> -->
    <div class="content">
        <div class="row mr-2">
            <div class="col-12 pt-3">
            <button @click="descargarLayout" type="button" class="btn btn-light mt-2 float-right" style="border-radius: 10px;">
                <i class="fas fa-arrow-circle-down fa-lg mr-2"></i>
                Descargar layout
            </button>
        </div>
        </div>
        <div class="row" v-if="divCarga">
            <div class="card target mt-4 container col-4">
                <div class="card-body">
                    <div class="row">
                        <h5 class="text-center">Carga los siguientes archivos:</h5>
                    </div>
    
                    <div class="card mt-3" style="border-radius: 17px;">
                        <div class="row fila">
                            <div class="col-2 p-2 ml-4">
                                <img src="./Tools/img/xlsx.png" alt="" height="60px">
                                <!-- <i style="color:rgb(0, 0, 0);" class="ml-2 mt-3 fas fa-file-excel fa-3x"></i> -->
                            </div>
                            <div class="col ">
                                <h4 class="titulo ml-2 pt-2">Excel</h4>
                                <div class="file-select" id="src-file1" >
                                    <input type="file" name="src-file1" @change="onChangeFileExcel($event)" aria-label="Archivo" accept=".csv">
                                </div>
                            </div>
                            <div class="col-3 mt-3" v-if="popover.ppvrCSV">
                                <CButton color="info" @click="mostrarExcel" class="btn-see">
                                    <i class="fas fa-arrow-to-bottom"></i>
                                </CButton>
                            </div>
                        </div>
                    </div>
    
                    <div class="card mt-2" style="border-radius: 17px;">
                        <div class="row fila">
                            <div class="col-2 p-2 ml-4">
                                <img src="./Tools/img/xml.png" alt="" height="60px">
                            </div>
                            <div class="col">
                                <h4 class="titulo ml-2 pt-2">XML</h4>
                                <div class="file-select" id="src-file1" >
                                    <input type="file" name="src-file1" @change="onChangeFileXML($event)" aria-label="Archivo" accept=".xml">
                                </div>
                                <!-- <input @change="onChangeFileXML($event)" type="file" class="file-select"/> -->
                            </div>
                            <div class="col-3 mt-3" v-if="popover.ppvrXML">
                                <CButton color="info" @click="mostrarXML" class="btn-see">
                                    <i class="fas fa-eye"></i>
                                </CButton>
                            </div>
                        </div>
                    </div>
    
                    <div class="card mt-2" style="border-radius: 15px;">
                        <div class="row fila">
                            <div class="col-2 p-2 ml-4">
                                <img src="./Tools/img/pdf.png" alt="" height="60px">
                            </div>
                            <div class="col">
                                <h4 class="titulo ml-2 pt-2">PDF</h4>
                                <div class="file-select" id="src-file1" >
                                    <input type="file" name="src-file1" @change="onChangeFilePDF($event)" aria-label="Archivo" accept=".pdf">
                                </div>
                                <!-- <input @change="onChangeFilePDF($event)" type="file" class="file-select"/> -->
                            </div>
                            <div class="col-3 mt-3" v-if="popover.ppvrPDF">
                                <CButton color="info" @click="mostrarPDF" class="btn-see">
                                    <i class="fas fa-eye"></i>
                                </CButton>
                            </div>
                        </div>
                    </div>
    
                    <button @click="enviarDocumentos" type="button" class="col-12 btn-sm btn btn-see p-2" style="color: white;">
                        <i class="fas fa-paper-plane mr-1"></i>
                         Enviar y validar
                    </button>
    
                </div>
            </div>
            
    
        </div>
    </div>
    
    <div class="foot">
        <p>&copy; 2024 Latino Seguros.</p>
    </div>
    
    <!-- Modal numero de importación -->
    <div>
        <CModal :show.sync="modals.info" ref="my-modal" :close-on-backdrop="false">
            <template #header-wrapper>
                <div class="card-header text-center">
                    <h5 style="color:white">Generación de operación de pago</h5>
                </div>
            </template>
            <template #footer-wrapper><span></span></template>
            <div class="card-body text-center">
                <h5 class="text-center">Se genero tu número de proceso de Importacion:</h5>
                <h5 style="color:green">{{ NumImportacion }}</h5>
                <h6>Te notificaremos en cuanto se realice el pago.</h6>
                <h6>¡Gracias!</h6>
            </div>
            <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                <CButton @click="modals.info = false" color="secondary" class="mr-2">
                    Ok
                </CButton>
            </CCardFooter>
        </CModal>
    </div>

    <!-- Lista siniestros invalidos -->
    <div v-if="divNoExistentes" class="container mt-2 mb-5">
        <div class="row">
            <div class="col-3"></div>
            <div class="col-6 mt-4">
                <button @click="reload" type="button" class="btn btn-secondary mb-2 btn-sm"> <i class="fad fa-step-backward mr-1"></i>Volver</button>
                <div class="card">
                    <div class="card-body text-center">
                        <h5 class="">Siniestros no existentes:</h5>
                        <ul v-for="(item, index) in listNoExistentes" :key="index" class="list-group">
                            <li class="list-group-item">{{item.Siniestro}}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-3"></div>
        </div>
    </div>

    <!-- Modal ver documento cargado -->
    <div>
        <CModal size="lg" :show.sync="modals.ver" ref="my-modal" :close-on-backdrop="false">
            <!-- <template #header-wrapper>
                <div class="card-header text-center">
                    <h5 style="color:white">Generación de operación de pago</h5>
                </div>
            </template> -->
            <template #footer-wrapper><span></span></template>
            <div class="card-body p-0">
                <iframe class="container iframePdf" :src="documento" frameborder="0"></iframe>
            </div>
            <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
                <CButton @click="modals.ver = false" color="secondary" class="mr-2">
                    Cerrar
                </CButton>
            </CCardFooter>
        </CModal>
    </div>
    <loading></loading>
  </div>
</template>

<script>
import readXlsxFile from 'read-excel-file'
import Loading from '../../componentes/ImgLoading/loading.vue'
import NavbarSas from './navbarSas.vue';
import Footer from './Tools/footer.vue'
export default {
components: {Loading, NavbarSas, Footer},
    data() {
      return {
        navigation: [],
        ArchivoExcel: "",
        ArchivoXml: "",
        ArchivoPDF: "",
        nomreArchivoExcel: "",
        nomreArchivoXml: "",
        tipoArchivoExcel: "",
        tipoArchivoXml: "",
        archivoBase64: "",
        SPV: "",
        documento: "",
        listSPV: [],
        cont: "",
        bodyExcel: {},
        listSiniestros: [],
        listSiniestrosTemp: [],
        listSiniestrosExistentes: [],
        listPPImportar: [],
        xmlItems:[],
        toasts: [],
        listNoExistentes: [],
        listCargarDocs: [],
        xml: [],
        uuid: "",
        cvvProve: "",
        RfcEmisor: "",
        Folio: "",
        subtotal: "",
        subtotal2: "",
        resSiniextros: "",
        NumImportacion: "",
        subtotalFactura: "",
        convertExcel: "",
        popover: {
            ppvrCSV: false,
            ppvrXML: false,
            ppvrPDF: false,
        },
        modals: { 
            info: false,
            ver: false
        },
        divCarga: true,
        divNoExistentes: false,
        profileId: localStorage.getItem("profileId")
      }
    },
    methods: {
        async mostrarExcel() {
            this.excel = ""
            let base64 = await this.convertBase64(this.ArchivoExcel);
            if(this.tipoArchivoExcel == "text/csv"){
                this.documento = 'data:text/csv;base64,' + base64;
            } 
            else if(this.tipoArchivoExcel == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"){
                this.documento = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64;
            }

        },
        async mostrarPDF() {
            this.excel = ""
            let base64 = await this.convertBase64(this.ArchivoPDF);
            this.modals.ver = true
            this.documento = 'data:application/pdf;base64,' + base64;

        },
        async mostrarXML() {
            this.excel = ""
            let base64 = await this.convertBase64(this.ArchivoXml);
            this.modals.ver = true
            this.documento = 'data:text/plain;base64,' + base64;
        },
        reload(){
            window.location.reload();
        },
        onChangeFileExcel(event) {
            this.ArchivoExcel = event.target.files[0];
            this.nomreArchivoExcel = event.target.files[0].name;
            this.tipoArchivoExcel = event.target.files[0].type;
            this.popover.ppvrCSV = true;
        },
        onChangeFileXML(event) {
            this.ArchivoXml = event.target.files[0];
            this.nomreArchivoXml = event.target.files[0].name;
            this.tipoArchivoXml = event.target.files[0].type;
            this.popover.ppvrXML = true;
        },
        onChangeFilePDF(event) {
            this.ArchivoPDF = event.target.files[0];
            this.popover.ppvrPDF = true;
        },
        convertBase64(blob) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
            resolve(reader.result.split(",")[1]);
            };
        });
        },
        async descargarLayout(){
            const payload = {
            metodo: "GETFILE",
            data: {
                psNombreArchivo: "LayoutExcel",
                psExtension: "." + "xlsx",
                psIdOperacion: 5
            },
            };
            try {
            const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    this.convertExcel = 'data:text/csv;base64,' + res;
                    var down = document.createElement('a');
                    down.href = this.convertExcel;
                    down.target = '_blank';
                    down.download = 'Layout'
                    document.body.appendChild(down);
                    down.click();
                    document.body.removeChild(down)
                }
            } //Fin try
            catch (error) {
                console.log(error);
            }
        },
        
        async enviarDocumentos(){
            if(this.tipoArchivoXml === 'text/xml'){
                this.archivoBase64 = await this.convertBase64(this.ArchivoXml)
                const payload = {
                metodo: "VALIDARDOCUMENTOSXML",
                data: {
                    DocumentXmlBase64:this.archivoBase64
                },
                };
                try {
                const response = await this.$store.dispatch("metodoPost", payload);
                    if (response) {
                        const res = this.$store.getters.getRespuestaREST;
                        if(res.TransactionProperties.length == 0)
                        {
                            this.$swal({
                                icon: "error",
                                title: "Documento XML invalido",
                                showConfirmButton: true,
                                background: '#fff',
                                backdrop: `
                                    rgba(0,0,123,0.4)
                                `,
                            customClass: {
                                popup: 'swal-custom-popup'
                            }
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.reload();
                                }
                            })
                        }
                        this.Folio = res.DatosAdicionales[0].valor
                        this.uuid = res.DatosAdicionales[1].valor
                        this.RfcEmisor = res.TransactionProperties[5].valueField
                        for (let i = 0; i < res.TransactionProperties.length; i++) {
                            if(res.TransactionProperties[i].keyField == "Subtotal")
                            this.subtotalFactura = res.TransactionProperties[i].valueField
                        }

                        const promise = new Promise((resolve, _) => {
                            resolve(this.searchProveedor());
                            });
                            promise.then( async _ => {
                                if(this.cvvProve.length > 20){
                                    this.$swal({
                                        icon: "error",
                                        title: "Error",
                                        text: `RFC Emisor: ${this.RfcEmisor} no encontrado.`,
                                        showConfirmButton: true,
                                        background: '#fff',
                                        width: '36rem',
                                        backdrop: `
                                        rgba(0,0,123,0.4)
                                        `,
                                        customClass: {
                                            popup: 'swal-custom-popup'
                                        }
                                    }).then((result) => {
                                        // if (result.isConfirmed) {
                                        //     window.location.reload();
                                        // }
                                    });
                                    return
                                }             
                                if(this.tipoArchivoExcel === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                                    if(res.TransactionProperties.length > 0){
                                        const payloadExcel = {
                                            metodo: "VALIDASINIESTROSEXISTENTES",
                                            data: {
                                                SiniestrosExistentes: await this.ValidaExcel()
                                            },
                                        }; 

                                        let subtotal = 0;
                                        let fact2 = 0;

                                        for (let c = 0; c < this.bodyExcel.length; c++) {
                                            subtotal += this.bodyExcel[c].Monto
                                        }
                                        fact2 = subtotal.toFixed(2);
                                        let decimalesFactura = fact2.split(".")[1]
                                        if(decimalesFactura == "00"){
                                            fact2 = fact2.split(".")[0]
                                        }
                                        if(this.subtotalFactura.split(".")[1] == "00"){
                                            this.subtotalFactura = this.subtotalFactura.split(".")[0]
                                        }
                                        if(this.subtotalFactura != fact2){
                                        this.$swal({
                                                icon: "error",
                                                title: "Error",
                                                text: `Subtotal Factura: ${this.subtotalFactura}, no coincide con Subtotal Siniestros: ${fact2}`,
                                                showConfirmButton: true,
                                                background: '#fff',
                                                width: '36rem',
                                                backdrop: `
                                                rgba(0,0,123,0.4)
                                                `,
                                                customClass: {
                                                    popup: 'swal-custom-popup'
                                                }
                                        }).then((result) => {
                                            if (result.isConfirmed) {
                                                window.location.reload();
                                            }
                                        });
                                        
                                    } 
                                       else {
                                           try {
                                               const responseExcel = await this.$store.dispatch("metodoPost", payloadExcel);
                                               if (responseExcel) {
                                                   const res = this.$store.getters.getRespuestaREST;
                                                   if(res.length == 0 ){
                                                       this.$swal({
                                                           icon: "error",
                                                           title: "Siniestros invalidos",
                                                           text:
                                                           "Solo se permiten números en el campo Siniestro",
                                                           showConfirmButton: true,
                                                           background: '#fff',
                                                           backdrop: `
                                                               rgba(0,0,123,0.4)
                                                           `,
                                                            customClass: {
                                                                popup: 'swal-custom-popup'
                                                            }
                                                       }).then((result) => {
                                                           if (result.isConfirmed) {
                                                               window.location.reload();
                                                           }
                                                       });
                                                   }
                                                   this.resSiniextros = this.$store.getters.getRespuestaREST[0].SiniestrosExistentes;
                                                   for (let i = 0; i < this.resSiniextros.length; i++) {
                                                       if(this.resSiniextros[i].Existente == "1") {
                                                           this.listSiniestrosExistentes.push(this.resSiniextros[i])
                                                       }
                                                       if(this.resSiniextros[i].Existente == "0")
                                                       {
                                                           this.listNoExistentes.push(this.resSiniextros[i])
                                                       }
                                                   }
                                                   if(this.listSiniestrosExistentes.length == this.resSiniextros.length){
                                                           this.generaNumImportacion();
                                                   } else {
                                                       this.$swal({
                                                           icon: "error",
                                                           title: "Error",
                                                           text:
                                                           "Siniestros invalidos",
                                                           showConfirmButton: true,
                                                           background: '#fff',
                                                           backdrop: `
                                                               rgba(0,0,123,0.4)
                                                           `,
                                                            customClass: {
                                                                popup: 'swal-custom-popup'
                                                            }
                                                       }).then((result) => {
                                                           if (result.isConfirmed) {
                                                               this.divCarga = false
                                                               this.divNoExistentes = true;
                                                           }
                                                       });
                                                   }
                                                   
                                               }
                                           } 
                                           catch (errorE) {
                                               this.$swal({
                                                   icon: "error",
                                                   title: "Error",
                                                   text:
                                                   "Siniestros invalidos",
                                                   showConfirmButton: true,
                                                   background: '#fff',
                                                   backdrop: `
                                                       rgba(0,0,123,0.4)
                                                   `,
                                                    customClass: {
                                                        popup: 'swal-custom-popup'
                                                    }
                                               });
                                           }

                                       }
                                    } //Fin if valida respuesta de documento xml
                                } //Fin if Valida archivo Excel
                                else {
                                    this.$swal({
                                        icon: "error",
                                        title: "Error",
                                        text:
                                        "Archivos Excel invalido, solo se permiten archivos .xlsx",
                                        showConfirmButton: true,
                                        background: '#fff',
                                        backdrop: `
                                            rgba(0,0,123,0.4)
                                        `,
                                        customClass: {
                                            popup: 'swal-custom-popup'
                                        }
                                    });
                                }
                            }
                        );

                    } //Fin if response
                } //Fin try
                catch (error) {
                console.log(error);
                }

            } else {
                this.$swal({
                icon: "error",
                title: "Error",
                text:
                "Archivo Xml invalido",
                showConfirmButton: true,
                backdrop: `
                rgba(0,0,123,0.4)
            `,
                customClass: {
                    popup: 'swal-custom-popup'
                }
            });
            }
            
            
        },
        async generaNumImportacion() {
            let Siniestros = {};
            let monto = 0;
            const promise = new Promise(async( resolve, _) => {
                resolve( this.getXML() );
                console.log(this.xml);

            });
            promise.then(async _ => {
            
                for (let e = 0; e < this.listSiniestrosExistentes.length; e++) {
                    if(this.listSiniestrosExistentes[e].Siniestro == this.bodyExcel[e].Siniestro){
                         monto = this.bodyExcel[e].Monto;
                    }
                    const CveCobertura = this.listSiniestrosExistentes[e].CveCobertura;
                    const Estimado = this.listSiniestrosExistentes[e].Estimado;
                    const Existente = this.listSiniestrosExistentes[e].Existente;
                    const IdCobertura = this.listSiniestrosExistentes[e].IdCobertura;
                    const siniestro = this.listSiniestrosExistentes[e].Siniestro;

                    Siniestros =  {
                        Siniestro: siniestro,
                        Monto: monto,
                        Existente: Existente,
                        Estimado: Estimado,
                        IdCobertura: IdCobertura,
                        CveCobertura: CveCobertura
                    }
                    this.listSiniestros.push(Siniestros);
                }

                let subtotaal = 0;
                for (let c = 0; c < this.bodyExcel.length; c++) {
                    subtotaal += this.bodyExcel[c].Monto
                }

                setTimeout(async  () => {
                    let total = "";
                    console.log(this.xml);
                    this.xml.map( (data) => {
                        if(data.keyField == 'Total'){
                            total = data.valueField
                        }
                    })
                    const payload = {
                        metodo: "PPIMPORTAR",
                        data: {
                            Factura: this.Folio,
                            Uuid: this.uuid,
                            Subtotal: Number(subtotaal.toFixed(2)),
                            RFC: this.RfcEmisor,
                            TipoImportacion: "Masiva",
                            TipoGasto: "36",
                            ClaveProveedor: this.cvvProve,
                            IdTipoServicio: "0", 
                            Siniestros: this.listSiniestros,
                            Total: total,
                            Archivos: [ 
                                {
                                    TipoDocumento:"0",
                                    Cantidad:"0"
                                }
                            ] 
    
                        },
                    };
                    console.log(payload);
                    try {
                        const response = await this.$store.dispatch("metodoPost", payload);
                        if (response) {
                            const res = this.$store.getters.getRespuestaREST[0];
                            this.NumImportacion = res.NumImportacion
                            if(res.NumImportacion != "" ){
                                this.modals.info = true;
                            }
                            this.listCargarDocs.push(this.ArchivoExcel)
                            this.listCargarDocs.push(this.ArchivoXml)
                            this.listCargarDocs.push(this.ArchivoPDF)
                            this.cargarDocumentos()
                        }
                    } 
                    catch (errorE) {
                        console.log(errorE);
                    }
                }, 2200) 
                }
            );

        },
        async ValidaExcel() {
            let returnArray = [];
            // if(this.tipoArchivoExcel === 'text/csv') {
            //     let that = this
            //     let Siniestros = {};
            //     let csvFile = this.ArchivoExcel;
            //     papa.parse(csvFile, {
            //         header: true,
            //         skipEmptyLines: true,
            //         dynamicTyping: true,
            //         complete: function(results) {
            //             for (let i = 0; i < results.data.length; i++) {
            //                 const spv  = results.data[i].SPV
            //                 const Subtotal  = results.data[i].Subtotal
            //                 Siniestros = {    
            //                     Siniestro: spv,
            //                     Monto: Subtotal
            //                 }
            //                 // that.listSPV.push(Siniestros)
            //                 that.listSPV[i] = Siniestros;
            //             }
            //             returnArray =  that.listSPV
                        
                        
            //         },
            //         complete: (results) => {
            //             for (let i = 0; i < results.data.length; i++) {
            //                 const spv  = results.data[i].SPV
            //                 const Subtotal  = results.data[i].Subtotal
            //                 Siniestros = {    
            //                     Siniestro: spv,
            //                     Monto: Subtotal
            //                 }
            //                 // that.listSPV.push(Siniestros)
            //                 that.listSPV[i] = Siniestros;
            //             }
            //             returnArray =  that.listSPV
                        
            //         }
            //     })
            //     console.log(that.listSPV);

            //     console.log(that.bodyExcel[1]); 
            //     console.log(this.bodyExcel);



            // } 
            // else if(this.tipoArchivoExcel === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
            const excel = await readXlsxFile(this.ArchivoExcel)
            const prueba = excel.slice(1, excel.length)
    
            for (let i = 0; i < prueba.length; i++) {
                this.SPV = prueba[i]
                const Siniestros = {
                    Siniestro: this.SPV[0],
                    Monto: this.SPV[1]
                }
                this.listSPV.push(Siniestros)
            }
            this.bodyExcel =  this.listSPV
            return this.bodyExcel
        },
        async searchProveedor(){
        const payload = {
            metodo: "PPLISTARPROVEEDORES",
            data: {
                // filtro: "LSE7406056F6"
                filtro: this.RfcEmisor
            },
        };
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST[0];
                if(res.Prestadores.length != 0){
                    this.cvvProve = res.Prestadores[0].CveProveedor
                } 
                
            }
        } //Fin try
        catch (error) {
            console.log(error);
        }
        },
        async cargarDocumentos() {
            for (let i = 0; i < this.listCargarDocs.length; i++) {

                let nombreArchivo = this.listCargarDocs[i].name.split(".")

                const base64 = await this.convertBase64(this.listCargarDocs[i])
                const payload = {
                metodo: "UPLOADFILE",
                data: {
                    psBase64: base64,
                    psNombreArchivo: nombreArchivo[0] + "_" + this.NumImportacion,
                    psExtension: "." + this.listCargarDocs[i].name.split(".").pop(),
                    psContentType: this.listCargarDocs[i].type,
                    psIdOperacion: 5, 
                },
                };
                try {
                const response = await this.$store.dispatch("metodoPost", payload);
                    if (response) {
                        const res = this.$store.getters.getRespuestaREST;
                    }
                } //Fin try
                catch (error) {
                    console.log(error);
                }
            }
        },
        async getXML(){
            let base64 = ''
            const promise = new Promise(async( resolve, _) => {
            resolve(
                base64 = await this.convertBase64(this.ArchivoXml)
            );
            });
            promise.then(async _ => {
                const payload = {
                    metodo: "VALIDARDOCUMENTOSXML",
                    data: {
                        DocumentXmlBase64: base64
                    },
                    };
                    try {
                    const response = await this.$store.dispatch("metodoPost", payload);
                        if (response) {
                            const res = this.$store.getters.getRespuestaREST;
                            this.xml = res.TransactionProperties
                            console.log(this.xml);
                        }}
                    catch(e){
                        console.log(e);
                    }
                }
            );
            

            
        },
    }
}

</script>


<style scoped>
.swal-custom-popup {
    color: #000; /* Cambia esto al color que prefieras */
    text-align: center;
}
.foot {
    /* position: sticky; */
    background-color: #003c71;
    height: 60px;
    margin-top:13%
}
.foot p {
    padding: 20px;
    color: #ffffff;
    text-align: center;
}
.btn-see{
    border-radius: 10px;
    background-image: linear-gradient(to right, #085da8, #003c71); /* Color de fondo verde */
    border: #003c71;
}
  /* modal alert */
  .btn-modal{
    background-color: #3085d6;
    color: #ffffff;
    font-size: medium;
}
.card-header-error {
    background-color: rgb(255, 255, 255);
    height: 8rem;
}
.iframePdf {
    height: 350px;
}
.card-header {
    background-color: rgb(33, 46, 102);
}
small{
    font-size: small;
}
.titulo {
    color: #000000;
    margin-bottom: 0%;
    margin-top: 2%;
}
.file-select {
  position: relative;
  display: inline-block;
  cursor: pointer !important;

}

.file-select::before {
  background-color: #ffffff;
  color: rgba(4, 12, 34, 0.664);
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  /* border-radius: 3px; */
  content: 'Seleccionar';
  position: absolute !important;
  left:5% !important;
  top: 20% !important;
  cursor: pointer !important;
}

.file-select input[type="file"] {
  opacity: 0 !important;
  width: 200px !important;
  height: 32px !important;
  display: inline-block !important;
  cursor: pointer !important;
}

#src-file1::before {
  content: 'Selecciona tu archivo';
  cursor: pointer !important;
}
#yourBtn {
  font-family: calibri;
  width: 170px;
  /* text-align: center; */
  margin-left:  20px;
  background-color: rgb(255, 255, 255);
  cursor: pointer;
}
.navbar{
    background-color: white;
    height: 90px;
}
.imagen {
    height: 50px;
}
.target{
    box-shadow: 5px 5px 5px rgb(218, 216, 216);
    border-radius: 10px;
    height: 28rem;
    width: 25rem;
}
.icono {
    color: #000000;
}
.columnaIcono{
    background-color: #ECE9E8;

}
.fila{
    margin-left: 1px;
}
.coltxt{
    padding: 10px;
    line-height: 0; 
}

</style>